import StepLearningEngagementController from './stepLearningEngagementController';

const StepLearningEngagementComponent = {
    template: require('./stepLearningEngagementView.html'),
    controller: StepLearningEngagementController
};

export default StepLearningEngagementComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/stepLearningEngagementComponent.js